import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KlmrFuelTruckPage } from '../klmr-fuel-truck/klmr-fuel-truck';

@IonicPage()
@Component({
  selector: 'page-klmr-fuel-truck-add',
  templateUrl: 'klmr-fuel-truck-add.html',
})
export class KlmrFuelTruckAddPage {
  fleetList: any = [];
  filledByList: any = [];
  containerList: any = [
    // "Truck",
    // "Gerry Cans",
    "Pod",
  ];
  serviceStationList:any = [
    "Service 1",
    "Service 2",
    "Service 3",
    "Service 4",
    "Service 5",
  ];
  serviceStationName:any = "";
  selectedFleet: any;
  selectedConatiner: any = "Pod";
  filledBy: any;
  selectOptions: any;
  createFuel: FormGroup;
  isUpdate: boolean = false;
  params: any = {};
  actionAllowed:boolean = false;
  disableSubmit:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder) {
    this.selectOptions = {
      mode: 'ios'
    };
    this.params = this.navParams.get('param');
    if (this.params) {
      this.isUpdate = true;

    }
    let currentDate = new Date()
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
    this.createFuel = this.formBuilder.group({
      date: new FormControl(date, [Validators.required]),
      filled_by: new FormControl('', [Validators.required]),
      user_id: new FormControl('', [Validators.required]),
      truck: new FormControl('Pod', [Validators.required]),
      diesel: new FormControl('Diesel', [Validators.required]),
      fuel: new FormControl('', [Validators.required]),
      price: new FormControl(''),
      amount: new FormControl(''),
      reminder_fuel: new FormControl(''),
      // fuel_station: new FormControl('', [Validators.required]),
      // cents: new FormControl('', [Validators.required]),
    });
    console.log("param", this.params)
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getMetaData();
  }

  
  async getMetaData() {
    this.filledByList = await this.getFilledBtList();
    let userName = await this.utiltiy.getStorage("name");
    let userId = await this.utiltiy.getStorage("userId");
    if(userName){
      this.createFuel.get(`filled_by`).setValue(userId);
      this.createFuel.get(`user_id`).setValue(userId);
      this.filledBy = userId;
    }
    if (this.params) {
      this.regenerateForm();
    }
  }

  fuelCalculator(evnt){
    let str = evnt.target.value;
    console.log("evnt is",str.length)
    if(str.length == 0){
      this.createFuel.get(`reminder_fuel`).setValue("0");
    }
    this.createFuel.get(`amount`).setValue(this.createFuel.value.fuel*this.createFuel.value.price);
  }

  async getFilledBtList() {
    this.filledByList = [];
    this.utiltiy.startLoading();
    return this.api.get("/prestart/fuel/users/get", false)
      .then((result: any) => {
        console.log("result", result)
        result.result.forEach(element => {
          element.name = element.firstName+" "+element.surname;
        });
        this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }

  regenerateForm() {
    this.createFuel.patchValue({
      date: this.params.date,
      filled_by: this.params.filled_by,
      truck: this.params.truck,
      diesel: this.params.diesel,
      fuel: this.params.fuel,
      price: this.params.price,
      amount: this.params.amount,
      reminder_fuel: this.params.reminder_fuel,
      // fuel_station: this.params.fuel_station,
      // cents: this.params.cents,
     
    });
    this.filledBy = this.params.filled_by;
    // this.serviceStationName = this.params.fuel_station;
    // this.selectedConatiner = this.params.truck;
  }

  dropDownChange(value,key) {
    this.createFuel.get(`${key}`).setValue(value);
  }

  submit() {
    this.utiltiy.startLoading();
    this.disableSubmit = true;
    
    console.log("this.credentialsForm.value", this.createFuel.value)
    let formKeys = Object.keys(this.createFuel.value);
    if (this.isUpdate) {
      let string = "";
      formKeys.forEach(key => {
        if(string.length == 0){
          string = string+""+key+"="+this.createFuel.value[key];
        }else{
          string = string+"&"+key+"="+this.createFuel.value[key];
        }
      });
      // let body = string+"&reminder_fuel=" + `${this.createFuel.value['fuel']}`;;
      let body = string;
      console.log("string-1",body);
      this.updateFuelTruck(body, this.params.id);
    } else {
      let formData: FormData = new FormData();
      formKeys.forEach(key => {
        formData.append(key, this.createFuel.value[key]);
      });
      // formData.append("reminder_fuel",this.createFuel.value['fuel']);
      this.addFuelTruck(formData);
    }



  }

  addFuelTruck(formData) {
    this.api.post(`/prestart/fuel/fuel_truck/store`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
    this.disableSubmit = false;

        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrFuelTruckPage);
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
    this.disableSubmit = false;

        this.utiltiy.toaster(err.error.message);
      })
  }

  updateFuelTruck(formData, id) {
    this.api.put(`/prestart/fuel/fuel_truck/update/${id}`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
    this.disableSubmit = false;

        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrFuelTruckPage);
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
    this.disableSubmit = false;

        this.utiltiy.toaster(err.error.message);
      })
  }

  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-fuel-truck-rw");
   }

  

}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel-truck-add/klmr-fuel-truck-add.ts